const tipoToString = {}

function convertTipoToEString (eInt) {
  let eStr
  switch (eInt) {
    case '1':
      eStr = '🖥'
      break
    case '2':
      eStr = '⌨️'
      break
    case '3':
      eStr = '📹'
      break
    case '4':
      eStr = '📠'
      break
    case '5':
      eStr = '💻'
      break
    case '6':
      eStr = '💻'
      break
    case '7':
      eStr = '🎛'
      break
    case '8':
      eStr = '🖨'
      break
    default:
      eStr = ''
      break
  }
  return eStr
}

tipoToString.install = function (Vue) {
  Vue.filter('tipoToHtml', (val) => {
    return convertTipoToEString(val)
  })
}



export default tipoToString



// WEBPACK FOOTER //
// ./src/filters/tipos.js